import { Grid, SxProps, TextField } from '@mui/material';
import { getIn, useFormikContext } from 'formik';

import { CountrySelectFormik } from '@uiKit/autocomplete/CountrySelectFormik';

import { countries } from '@src/resources/countries';

import { IFormAddressFields } from './types';

interface FormAddressFieldsProps {
  sx?: SxProps;
}

export const FormAddressFields = ({ sx }: FormAddressFieldsProps) => {
  const { errors, handleBlur, handleChange, touched, values } = useFormikContext<IFormAddressFields>();

  return (
    <Grid sx={sx} container spacing={2}>
      <Grid size={{ xs: 12 }}>
        <CountrySelectFormik
          value={countries.find((option) => option?.code === values?.countryCode) || null}
          name="countryCode"
          options={countries}
        />
      </Grid>
      <Grid size={{ md: 6, xs: 12 }}>
        <TextField
          label="Street Address"
          name="addressLine1"
          fullWidth
          required
          onBlur={handleBlur}
          onChange={handleChange}
          value={values.addressLine1}
          variant="outlined"
          error={Boolean(getIn(touched, 'addressLine1') && !!getIn(errors, 'addressLine1'))}
          helperText={getIn(touched, 'addressLine1') && getIn(errors, 'addressLine1')}
        />
      </Grid>
      <Grid size={{ md: 6, xs: 12 }}>
        <TextField
          fullWidth
          label="Street Address Line 2"
          name="addressLine2"
          onBlur={handleBlur}
          onChange={handleChange}
          value={values.addressLine2}
          variant="outlined"
          error={getIn(touched, 'addressLine2') && !!getIn(errors, 'addressLine2')}
          helperText={getIn(touched, 'addressLine2') && getIn(errors, 'addressLine2')}
        />
      </Grid>
      <Grid size={{ md: 4, xs: 12 }}>
        <TextField
          fullWidth
          required
          name="locality"
          label="City"
          onBlur={handleBlur}
          onChange={handleChange}
          value={values.locality}
          variant="outlined"
          error={getIn(touched, 'locality') && !!getIn(errors, 'locality')}
          helperText={getIn(touched, 'locality') && getIn(errors, 'locality')}
        />
      </Grid>
      <Grid size={{ md: 4, xs: 12 }}>
        <TextField
          fullWidth
          required
          name="administrativeArea"
          label="State / Province"
          onBlur={handleBlur}
          onChange={handleChange}
          value={values.administrativeArea}
          variant="outlined"
          error={getIn(touched, 'administrativeArea') && !!getIn(errors, 'administrativeArea')}
          helperText={getIn(touched, 'administrativeArea') && getIn(errors, 'administrativeArea')}
        />
      </Grid>
      <Grid size={{ md: 4, xs: 12 }}>
        <TextField
          fullWidth
          required
          name="postalCode"
          label="Postal / Zip value"
          onBlur={handleBlur}
          onChange={handleChange}
          value={values.postalCode}
          variant="outlined"
          error={getIn(touched, 'postalCode') && !!getIn(errors, 'postalCode')}
          helperText={getIn(touched, 'postalCode') && getIn(errors, 'postalCode')}
        />
      </Grid>
    </Grid>
  );
};
